import { render, staticRenderFns } from "./NetdocBCDOverview.vue?vue&type=template&id=02ee1642&scoped=true"
import script from "./NetdocBCDOverview.vue?vue&type=script&lang=js"
export * from "./NetdocBCDOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee1642",
  null
  
)

export default component.exports